export const ADD_SESSION = 'ADD_SESSION'
export const DELETE_SESSION = 'DELETE_SESSION'
export const OPEN_HALL = 'OPEN_HALL'
export const CLOSE_HALL = 'CLOSE_HALL'
export const ADD_SEAT = 'ADD_SEAT'
export const DELETE_SEAT = 'DELETE_SEAT'
export const BUY_TICKETS = 'BUY_TICKETS'
export const CLOSE_TICKETS = 'CLOSE_TICKETS'
export const OPEN_CALENDAR = 'OPEN_CALENDAR'
export const CLOSE_CALENDAR = 'CLOSE_CALENDAR'
export const OPEN_FORM = 'OPEN_FORM'
export const CLOSE_FORM = 'CLOSE_FORM'
